// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"marketing-redirections_wrapper__U_DhO","content":"marketing-redirections_content__1ua7a","spinner-wrapper":"marketing-redirections_spinner-wrapper__2xr3S"};